import { render, staticRenderFns } from "./size.vue?vue&type=template&id=70ef547b"
import script from "./size.vue?vue&type=script&lang=js"
export * from "./size.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports